import * as Sentry from "@sentry/react"

/**
 * 5.2.2 Traceable Error Codes (TRC)
 * Format: TRC-[CATEGORY]-[BASE36_TIMESTAMP]-[4_CHAR_RANDOM]
 * Example: TRC-DEC-M8KV2-A3FX
 */
export type TRCCategory = "DEC" | "KEY" | "UPL" | "SES"

export const generateTRCCode = (category: TRCCategory): string => {
  const ts = Math.floor(Date.now() / 1000)
    .toString(36)
    .toUpperCase()
    .slice(-5)
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"
  const rand = Array.from(
    { length: 4 },
    () => chars[Math.floor(Math.random() * chars.length)]
  ).join("")
  return `TRC-${category}-${ts}-${rand}`
}

/**
 * 5.2.1 Standard Log Structure
 * All fields are non-sensitive. Key values, encrypted blobs, and pre-signed
 * URLs must never be included.
 */
export interface SentryEncryptionPayload {
  error_category: TRCCategory
  error_type: string
  workspace_id: string
  error_code: string
  step_trail: string
  step_failed?: string
  key_type?: string
  encryption_mode?: string
  keys_failed?: number
  keys_total?: number
  /** File name only — never the URL */
  file_name?: string
  file_type?: string
  build_id?: string
  key_index?: number
  conversation_code?: string
  key_path_tried?: string
  [key: string]: unknown
}

export const captureSentryEncryptionEvent = (
  message: string,
  payload: SentryEncryptionPayload
): void => {
  Sentry.captureMessage(message, {
    level: "error",
    tags: {
      error_code: payload.error_code,
      error_category: payload.error_category,
      error_type: payload.error_type,
    },
    extra: payload,
  })
}
